<template>
  <div>
    <Dialog
        :dismissableMask="true"
        :style="{ width: '35vw' }"
        :modal="true"
        :visible.sync="show"
        @hide="closeDialog"
        :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <i style=" transform: scale(1.7);  " class="pi pi-th-large"></i>
        <h1>הוספת קישור</h1>
      </template>

      <div class="p-pt-4 p-fluid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="lastname6">כותרת</label>
          <InputText  type="text" v-model="newItem.title" />
        </div>
          <div class="p-field p-col-12 p-md-6">
          <label >תיאור</label>
          <InputText  type="text" v-model="newItem.description" />
        </div>
          <div class="p-field p-col-12 p-md-6">
          <label >קישור</label>
          <InputText  type="text" v-model="newItem.link" />
        </div>
          <div class="p-field p-col-12 p-md-6">
          <label >קישור לתמונה</label>
          <InputText  type="text" v-model="newItem.imageUrl" />
        </div>
      </div>

      <template #footer>
        <Button
            label="ביטול"
            icon="pi pi-times"
            @click="closeDialog"
            class="p-button-secondary"
        />
        <Button class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
      </template>
    </Dialog>
  </div>
</template>

<script>
import Service from "../service/Service";
const { v4: uuidv4 } = require("uuid");
export default {
  service: null,
  props: {
    show: Boolean,
  },
  created() {

    this.service = new Service();
  },
  mounted() {
    this.setNewItwmFields();
  },
  data() {
    return {
      newItem: null,
    };
  },

  methods: {
    setNewItwmFields() {
      this.newItem = {
        id: uuidv4(),
        title: null,
        link: null,
        description: null,
          imageUrl: null,
          active: true
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {
        await this.service
          .post(this.newItem,'external-link')
          .then((data) => {
            this.$emit("addItem", this.newItem);
            this.setNewItwmFields();
            this.openNotification(
              "top-right",
              "success",
              `<i class='bx bx-select-multiple`,
              `מעולה`,
              `המידע התתוסף במערכת`
            );

            this.closeDialog();
          })
          .catch(() => {
            this.openNotification(
              "danger",
              `אופס`,
              `אולי קיים כבר רשומה עם מזהה זהה`
            );
          });
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>

<style >
</style>